import { css } from 'styled-components'

export const StyleOverride = css`
  * {
    box-sizing: border-box;
  }

  button[title] {
    padding: 0px;
    background-color: transparent;
    color: inherit;
  }
`
